'use client';

import { __styles, mergeClasses } from "@griffel/react";
import { useMenuItemStyles_unstable } from "../MenuItem/useMenuItemStyles.styles.js";
export const menuItemLinkClassNames = {
  root: 'fui-MenuItemLink',
  icon: 'fui-MenuItemLink__icon',
  checkmark: 'fui-MenuItemLink__checkmark',
  content: 'fui-MenuItemLink__content',
  secondaryContent: 'fui-MenuItemLink__secondaryContent'
};
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__styles({
  resetLink: {
    w71qe1: "f1iuv45f",
    Bkioxbp: "f9pkogg",
    I8pafv: "foe20s3",
    dvvfom: "f1kn6jj"
  }
}, {
  d: [".f1iuv45f{text-decoration-line:none;}", ".f9pkogg{text-decoration-thickness:initial;}", ".foe20s3{text-decoration-style:initial;}", ".f1kn6jj{text-decoration-color:initial;}"]
});
/**
 * Apply styling to the MenuItemLink slots based on the state
 */
export const useMenuItemLinkStyles_unstable = state => {
  useMenuItemStyles_unstable(state);
  const styles = useStyles();
  // eslint-disable-next-line react-hooks/immutability
  state.root.className = mergeClasses(menuItemLinkClassNames.root, styles.resetLink, state.root.className);
  if (state.icon) {
    // eslint-disable-next-line react-hooks/immutability
    state.icon.className = mergeClasses(menuItemLinkClassNames.icon, state.icon.className);
  }
  if (state.content) {
    // eslint-disable-next-line react-hooks/immutability
    state.content.className = mergeClasses(menuItemLinkClassNames.content, state.content.className);
  }
  if (state.secondaryContent) {
    // eslint-disable-next-line react-hooks/immutability
    state.secondaryContent.className = mergeClasses(menuItemLinkClassNames.secondaryContent, state.secondaryContent.className);
  }
  if (state.checkmark) {
    // eslint-disable-next-line react-hooks/immutability
    state.checkmark.className = mergeClasses(menuItemLinkClassNames.checkmark, state.checkmark.className);
  }
  return state;
};